// 通知

$(window).on('load', function() {
    //globalNaviの高さ分、Y方向にずらす
    let gNavHeight = $('#globalNav').outerHeight()
    $('.notification_window').css('top',gNavHeight+'px');
});

$(() => {
    // 通知領域の表示
    $('#js-notification, .js-close_notification_window').on('click',function(){
        if($('.notification_window').is(':visible')){
            $('.notification_window').hide().css('right','-450px');
        }else{
            $('.notification_window').show().animate({'right' :0}, 200);
        }

        // 初回はデータ取得
        if($('#js-notificationContainer').find('.notification_item').length == 0){
            // アクター取得
            const actor = location.pathname.split("/")[1];
            // 通知データの取得
            $.ajax({
                url: '/'+actor+'/get_notifications',
                type: 'POST',
                dataType: 'json',
                timeout: 3000
            }).done(function(data, textStatus, jqXHR) {
                if(data.count > 0){
                    $.each(data.notifications,
                        function(index,notification){
                            let template = $($('template#js-notificationRow').clone().html());
                            template.find('h4').text(notification.full_title);
                            template.find('.js-notification_content').text(notification.content);
                            template.find('.js-notification_comment').html(notification.comment);
                            template.find('.js-notification_date').text(notification.date);
                            if(notification.open_flag > 0){
                                template.find('.notification_item-check i').addClass('far fa-circle');
                            }else{
                                template.find('.notification_item-check i').addClass('fas fa-circle');
                            }
                            template.attr('href', notification.link);
                            $('#js-notificationContainer').append(template);
                    });
                };
            }).fail(function(jqXHR, textStatus, errorThrown ) {
            }).always(function(){
            });
        }
    });
});
